import React from 'react';
import FormItem from '../FormItem';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { FormValidation } from '@/helpers/formValidations';
import { useTranslation } from 'react-i18next';

type Props = {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
};

export default function EmergencyContractForm({ register, errors }: Props) {
  const { t } = useTranslation();
  return (
    <>
      {/* End .col */}
      <div className="col-12 d-flex align-items-center">
        <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
        <div className="fw-bold text-18 text-blue-1  rounded-2 px-10 text-uppercase">{t('agentRegister_EmergencyContact')}</div>
        <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
      </div>

      <div className="col-6">
        <FormItem errors={errors} label={t('base.FirstName')} name="ecFirstName">
          <input type="text" {...register('ecFirstName')} />
        </FormItem>
      </div>

      <div className="col-6">
        <FormItem errors={errors} label={t('base.LastName')} name="ecLastName">
          <input type="text" {...register('ecLastName')} />
        </FormItem>
      </div>
      <div className="col-6">
        <FormItem errors={errors} label={t('base.Email')} name="ecEmail">
          <input {...register('ecEmail', FormValidation.Email)} />
        </FormItem>
      </div>
      <div className="col-6">
        <FormItem errors={errors} label={t('base.PhoneNumber')} name="ecPhoneNumber">
          <input {...register('ecPhoneNumber', FormValidation.PhoneNumber)} />
        </FormItem>
      </div>
    </>
  );
}
